import { clearAllData, platformNavigate } from "../../configs/utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { StoreKey } from "../../configs/api";
import { ROUTE } from "../../routes";
export const YesAction = async (action, _datastore, { navigate, hidePopup, instrumentTrack, openNewTab }) => {
    instrumentTrack("LOGOUT_BUTTON_CLICKED");
    await hidePopup();
    await clearAllData();
    await AsyncStorage.removeItem(StoreKey.userContext);
    await AsyncStorage.removeItem("applicationState");
    await platformNavigate(ROUTE.PLATFORM_SIGN_UP);
};
export const NoAction = async (action, _datastore, { hidePopup }) => {
    console.warn('**** NoAction Action Triggered ****', action);
    await hidePopup();
};
